import jwt_decode from "jwt-decode";

export const getClaims = (jtwToken: string) => {
  return jwt_decode(jtwToken) as any;
}